const ROLE_LABELS: Record<string, string> = {
  iwocapay_seller_admin: 'admin',
  iwocapay_seller_editor: 'editor',
  iwocapay_seller_contributor: 'contributor',
  iwocapay_seller_viewer: 'viewer',
  customers: 'owner',
  // 'team' is the canonical staff marker (see useUserGroups' isStaff); label it
  // explicitly so staff/impersonation sessions are filterable in Amplitude
  // rather than indistinguishable from a seller with no role assigned.
  team: 'staff',
};

// context.groups is the raw backend group list for the current (or impersonated)
// user and includes non-seller groups. Keep only the known groups and emit clean
// labels; unknown/other backend groups are dropped.
export const getUserRoles = (groups: string[]): string[] =>
  groups.map((group) => ROLE_LABELS[group]).filter(Boolean);
